import React from 'react';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './FileButton.module.css';
import { CommonButton } from '_components';


export class FileButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : ''} onClick={this.props.onClick} size={this.props.size} className={cls} type='round' >
                <FontAwesomeIcon icon={faFileAlt} color="#717271" />
            </CommonButton>
        );
    }
}

